module.exports = __webpack_public_path__ + "static/media/smileyface.6d86b932.png";